export default __webpack_public_path__ + "static/media/org-metrics.1510f81b.svg";